import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import i18n from "i18next";

import { useMatchRoute } from "./use-match-route";

export const useFaq = () => {
  const tag = useMatchRoute()?.tag;
  const { lang } = useParams();

  const language = lang || i18n.language;

  return {
    faqItems: useSelector(
      state => state.content.content.store?.[tag]?.[language]?.faq,
    ),
  };
};
